<template>
  <bim-popup
    class="request-model__popup"
    title=""
    width="530px"
    :value="show"
    @input="closeModal"
  >
    <div v-if="slide.current === slide.REQUEST" class="slide request">
      <form
        :data-vv-scope="formRequest"
        @submit.prevent="sendRequest(formRequest)"
      >
        <bim-text-accent bold class="mb-6 text-center pt-10">Поможем найти модель</bim-text-accent>
        <bim-text-medium class="mb-9 text-center request__info-text">Мы готовы оказать содействие в получении новых моделей. Пожалуйста заполните форму ниже и мы направим запрос напрямую ответственным специалистам производителя.</bim-text-medium>

        <div class="error mb-4" v-if="errors.has('user_fantasy', formRequest)">Поле обязательно для заполнения</div>
        <bim-text-area
          class="mb-6 request__input-info"
          :class="{ error: errors.has('user_fantasy', formRequest) }"
          v-validate="'required'"
          data-vv-name="user_fantasy"
          v-model="formData.description"
          placeholder="Максимально подробно опишите то, что вы ищете*"
          width="100%"
        />
        <bim-multi-select
          class="mb-6"
          :options="filesDataParsed"
          placeholder="Формат файла"
          v-model="formData.fileFormat"
        />
        <bim-multi-select
          class="mb-6"
          :options="manufacturersDataParsed"
          placeholder="Производители"
          v-model="formData.manufacturers"
        />
        <div class="button-group pb-9 d-flex flex-column flex-sm-row">
          <bim-button class="button mr-sm-6 mb-6 mb-sm-0" size="l" label="Отменить" color="gray" @click.prevent="cancelRequest(slide.REQUEST)"></bim-button>
          <bim-button class="button" size="l" :label="user ? 'Отправить' : 'Далее'"></bim-button>
        </div>
      </form>
    </div>

    <div v-if="slide.current === slide.CONTACTS" class="slide contacts">
      <form
        :data-vv-scope="formContacts"
        @submit.prevent="sendRequest(formContacts)"
      >
        <bim-text-accent bold class="mb-6 text-center pt-9">Для связи с вами</bim-text-accent>
        <bim-text-medium class="mb-9 text-center contacts__info-text">Пожалуйста, укажите свои контактные данные</bim-text-medium>

        <div class="error mb-4" v-if="errors.has('name', formContacts) || errors.has('email', formContacts)">Заполните, пожалуйста, обязательные поля</div>
        <bim-input
          class="contacts__input-name mb-6"
          v-model="formData.name"
          placeholder="Имя*"
          v-validate="'required'"
          data-vv-name="name"
          :valid="errors.has('name', formContacts) ? false : null"
          :data-vv-as="$t('«Имя»')"
        />
        <div class="d-block d-md-flex">
          <bim-input
            @keydown.enter="resolveEnterKeySubmit"
            class="contacts__input-email mr-0 mr-md-6 mb-6"
            v-model="formData.email"
            placeholder="Электронная почта*"
            v-validate="'required|email'"
            data-vv-name="email"
            dadataType="email"
            :data-vv-as="$t('«Электронная почта»')"
            :valid="errors.has('email', formContacts) ? false : null"
          />
          <bim-input
            @keydown.enter="resolveEnterKeySubmit"
            type="tel"
            class="contacts__input-phone mb-6"
            v-model="formData.phone"
            placeholder="Телефон"
          />
        </div>
        <div class="button-group pb-9 d-flex flex-column flex-sm-row">
          <bim-button class="button mr-sm-6 mb-6 mb-sm-0" size="l" label="Назад" color="gray" @click.prevent="setSlideRequest"></bim-button>
          <bim-button class="button" size="l" label="Отправить"></bim-button>
        </div>
      </form>
    </div>

    <div v-if="slide.current === slide.QUIT" class="slide quit">
      <bim-text-h5 bold class="text-center mb-6 quit__title-text pt-11 mt-8">Вы уверены, что хотите выйти?</bim-text-h5>
      <bim-text-main class="text-center mb-10 quit__info-text">Вся указанная информация будет потеряна</bim-text-main>
      <div class="button-group pb-11 d-flex flex-column flex-sm-row">
        <bim-button class="button px-0 mr-sm-6 mb-6 mb-sm-0" size="l" label="Вернуться к заявке" color="gray" @click="slide.current = slide.last"></bim-button>
        <bim-button class="button px-0" size="l" label="Подтвердить выход" color="red" @click="closeModal"></bim-button>
      </div>
    </div>

    <preloader v-if="loading" />

  </bim-popup>
</template>

<script>
import bimPopup from "@bimlib/components/bimPopup"
import bimTextH5 from "@bimlib/components/bimTextH5"
import bimTextAccent from "@bimlib/components/bimTextAccent"
import bimTextMain from "@bimlib/components/bimTextMain"
import bimTextMedium from "@bimlib/components/bimTextMedium"
import bimTextarea from "@bimlib/components/bimTextarea"
import bimMultiSelect from "@bimlib/components/bimMultiSelect"
import bimButton from "@bimlib/components/bimButton"
import bimInput from "@bimlib/components/bimInput"

import { mapActions, mapGetters } from "vuex"
export default {
  model: {
    prop: "show",
    event: "close",
  },
  components: {
    "bim-popup": bimPopup,
    "bim-text-h5": bimTextH5,
    "bim-text-accent": bimTextAccent,
    "bim-text-main": bimTextMain,
    "bim-text-medium": bimTextMedium,
    "bim-text-area": bimTextarea,
    "bim-multi-select": bimMultiSelect,
    "bim-button": bimButton,
    "bim-input": bimInput,
  },
  data() {
    return {
      user: null,
      loading: false,
      formRequest: "formRequest",
      formContacts: "formContacts",
      filesData: [],
      formData: {
        description: '',
        fileFormat: [],
        manufacturers: this.organizationId ? [this.organizationId] : [],
        name: '',
        email: '',
        phone: ''
      },
      slide: {
        current: 0,
        last: null,

        REQUEST: 0,
        CONTACTS: 1,
        QUIT: 2,
      },
    };
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    organizationId: Number,
  },
  watch: {
    async show(val) {
      /**
       * Если окно открывается второй раз, заносим производителя снова
       */
      if (
        !isNaN(this.organizationId) &&
        val &&
        this.manufacturersData.length &&
        !this.formData.manufacturers.length
      ) {
        this.formData = new FormData()
        this.formData.manufacturers.push(
          this.manufacturersData.filter(
            man => man.value == this.organizationId
          )[0].value
        )
      }
    },
    contentLoaded(val) {
      this.loadData(val)
    }
  },
  async created() {
    this.loadData(this.contentLoaded)

    window.addEventListener("keydown", this.listenKeyEnter)

    try {
      const user = await this.$user.fetchContext()
      this.user = user
    }
    catch(e) {
      console.error(e)
    }
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.listenKeyEnter)
  },
  computed: {
    ...mapGetters([
      'manufacturersData',
      'contentLoaded'
    ]),
    filesDataParsed() {
      return this.filesData.map(file => ({
        label: `*.${file.code} (${file.name})`,
        value: file.id
      }))
    },
    manufacturersDataParsed() {
      return this.manufacturersData.map(company => ({
        label: company.name_short,
        value: company.id
      }))
    }
  },
  methods: {
    ...mapActions([
      'getManufacturerData',
      'getFilesData'
    ]),
    loadData(contentLoaded) {
      if (contentLoaded) {
        if (!this.filesData.length) {
          this.getFilesData()
            .then(data => this.filesData = data)
        }
        if (!this.manufacturersData.length) {
          this.getManufacturerData()
        }
      }
    },
    setSlideRequest() {
      this.slide.current = this.slide.REQUEST
    },
    listenKeyEnter(event) {
      if (!this.show) return
      const textarea = event.path.filter(el => el.nodeName === "TEXTAREA")
      if (textarea.length) return
      const { current, REQUEST } = this.slide
      if (event.key === "Enter") {
        const scope = current === REQUEST ? this.formRequest : this.formContacts
        this.sendRequest(scope)
      }
    },
    resolveEnterKeySubmit(event) {
      this.sendRequest(this.formContacts)
    },
    closeModal() {
      const { current, REQUEST, CONTACTS } = this.slide;

      if (current === REQUEST) {
        return this.cancelRequest();
      }

      if (current === CONTACTS) {
        return this.cancelContacts();
      }

      this.resetModal()
      this.$emit('close', false);
    },
    resetModal() {
      this.formData.description = ""
      this.formData.manufacturers = []
      this.formData.fileFormat = []

      this.formData.name = ""
      this.formData.email = ""
      this.formData.phone = ""

      this.slide.current = this.slide.REQUEST;
    },
    filledRequestFields() {
      const { description, fileFormat, manufacturers } = this.formData
      if (
        description.length ||
        fileFormat.length ||
        manufacturers.length
      ) {
        return true
      }
      return false
    },
    filledContactsFields() {
      const { name, email, phone } = this.formData
      if (
        name.length ||
        email.length ||
        phone.length
      ) {
        return true
      }
      return false
    },
    cancelRequest() {
      if (this.filledRequestFields()) {
        this.slide.last = this.slide.REQUEST;
        this.slide.current = this.slide.QUIT;
      }
      else {
        this.$emit('close', false);
      }
    },
    cancelContacts() {
      if (this.filledContactsFields() || this.filledRequestFields()) {
        this.slide.last = this.slide.CONTACTS;
        this.slide.current = this.slide.QUIT;
      }
      else {
        this.slide.current = this.slide.REQUEST
        this.$emit('close', false)
      }
    },
    async sendRequest(scope) {
      send = send.bind(this)

      const valid = await this.$validator.validateAll(scope)
      if (!valid) return

      if (scope === this.formRequest) {

        if (!this.user) {
          return this.slide.current = this.slide.CONTACTS
        }

        const { firstName, lastName, email, phone } = this.user;

        this.formData.name = `${firstName} ${lastName}`
        this.formData.email = email
        this.formData.phone = phone

        return send()
      }

      if (scope === this.formContacts) {
        return send()
      }

      function send() {
        const data = {}

        for (let key in this.formData) {
          const value = this.formData[key]
          if (value.length) {
            data[key] = value
          }
        }

        this.loading = true
        axios
          .post('/web-api-2/needmodel', data)
          .then(res => {
            if (res.data.success || res.status === 200) {
              this.resetModal()
              this.$emit("close", false)

              this.$noty.success(
                renderNoty('Успешно', 'Ваш запрос был отправлен производителю'),
                {
                  killer: true,
                  closeWith: [],
                  timeout: 5000,
                  layout: 'bottomRight',
                  progressBar: false,
                }
              )
            } else {
              this.$noty.error(
                renderNoty('Ошибка.', 'Что-то пошло не так, попробуйте снова.', 'error'),
                {
                  killer: true,
                  closeWith: [],
                  timeout: 5000,
                  layout: 'bottomRight',
                  progressBar: false,
                },
              )
            }

            setTimeout(( ) => {
              const noty = document.getElementsByClassName("noty_layout")[0]
              const noty_bar = noty.firstChild
              const noty_body = noty_bar.firstChild

              noty.style.width = 'auto'
              noty.style.opacity = 0.9
              noty_body.style.padding = 0
              noty_bar.style.border = 'none'

              const closeButton = document.getElementById("noty_img_close")
              closeButton.addEventListener("click", ( ) => noty.style.opacity = 0)
            }, 0)

            function renderNoty(title, text, type='primary') {

              let titleColor
              if (type === 'primary') titleColor = '#00afa1'
              if (type === 'error') titleColor = '#f74949'

              return `
                <div
                  style="padding:24px;position:relative;"
                >
                  <div
                    style="color:${titleColor};font-size: 18px;font-weight: bold;line-height: 1.44;"
                  >
                    ${title}
                  </div>
                  <div
                    style="color: #4d4d4d;font-size: 14px;line-height: 1.57;letter-spacing: 0.2px;"
                  >
                    ${text}
                  </div>
                  <img
                    src="/dist/assets/front_white/img/vacancy/close-big.svg"
                    style="position: absolute;top: 14px;right: 14px;width: 15px;cursor: pointer;"
                    id="noty_img_close"
                  />
                </div>
              `
            }
          })
          .catch(console.error)
          .finally(( ) => {
            this.loading = false
          })
      }
    },
  },
};
</script>


<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.request-model__popup {
  ::v-deep .multi__select__wrp {
    .selected__items {
      max-height: 100px;
      overflow: auto;
    }
    .options__items {
      @include scrollbar();
    }
  }

  ::v-deep .modal-body {
    padding: 0 42px;
    overflow: auto;

    @media screen and (max-width: $breakpoint-sm) {
      padding: 0 20px;
    }
  }

  ::v-deep .modal-content {
    width: 100%;
    padding: 0;
    overflow: visible;
  }

  ::v-deep .modal-header {
    padding: 0;
  }
}

.text-center {
  text-align: center;
}

.slide {
  width: calc(530px - 42px * 2);

  @media screen and (max-width: $breakpoint-sm) {
    width: 100%;
  }
}

.slide .error {
  color: $warning;
  font-size: 12px;
}

.button-group {
  display: flex;

  .button {
    flex: 1 1 50%;
    box-sizing: border-box;
    height: auto;

    @media screen and (max-width: $breakpoint-sm) {
      flex: 0 0 100%;
    }
  }
}

.request__input-info {
  &.error ::v-deep .bim-textarea {
    border-color: $warning;
  }
}

.request__info-text {
  line-height: 1.57 !important;
}

.contacts__info-text {
  line-height: 1.36 !important;
}

.quit__info-text {
  line-height: 1.5 !important;
  letter-spacing: 0.2px !important;
}

.quit__title-text {
  padding: 0 48px;
}

.contacts__input-email,
.contacts__input-phone {
  width: 50%;

  // @media screen and (max-width: $breakpoint-md) {
  //   width: 100%;
  // }
}
</style>
